import { Upload } from 'antd'
import styled from 'styled-components'

const UploadWideStyled = styled(Upload)`
  width: 100%;

  .ant-upload,
  .ant-upload-select,
  .ant-upload-select-picture-card,
  .ant-upload-select-picture {
    width: 100% !important;
  }

  .ant-upload-select {
    display: block;
  }

  .ant-upload-select > .ant-upload {
    display: block;
    width: 100% !important;
  }
`

const uploadButtonWideStyles = {
  width: '100%',
  minHeight: 174,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  borderRadius: 14,
  border: '2px solid rgba(214, 203, 226, 1)',
  background:
    'linear-gradient(90deg, rgba(241, 255, 244, 1) 0%, rgba(243, 237, 250, 1) 70%, rgba(230, 218, 245, 1) 100%)',
  cursor: 'pointer',
  userSelect: 'none',
  position: 'relative'
}

const headerTextStyles = {
  fontSize: 18,
  fontWeight: 500,
  color: '#1B1B1B',
  textAlign: 'center',
  display: 'flex',
  height: 42,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%'
}

const fileContainerStyles = {
  width: '100%',
  backgroundColor: 'rgba(255,255,255,0.85)',
  borderBottomLeftRadius: 12,
  borderBottomRightRadius: 12,
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center',
  padding: 12
}

const fileRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10
}

const fileMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  minWidth: 0
}

const fileNameStyles = {
  fontSize: 16,
  fontWeight: 600,
  color: '#1B1B1B',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: 240
}

/**
 * Match antd Upload `picture-card` feel:
 * square thumb with subtle border and small radius.
 */
const filePreviewThumbStyles = {
  width: 104,
  height: 104,
  borderRadius: 2,
  border: '1px solid rgba(0, 0, 0, 0.06)',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  flexShrink: 0
}

const filePreviewThumbImageStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 2,
  display: 'block'
}

const deleteButtonStyles = {
  padding: 16,
  borderRadius: 50,
  border: 1,
  backgroundColor: 'rgba(225, 236, 255, 1)'
}

const emptyOuterStyles = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  alignItems: 'center'
}

const emptyIconsRowStyles = {
  display: 'flex',
  justifyContent: 'space-around',
  width: '100%',
  gap: 4,
  paddingLeft: 12,
  paddingRight: 12
}

const uploadButtonStyles = { display: 'none' }

export {
  UploadWideStyled,
  uploadButtonWideStyles,
  headerTextStyles,
  fileContainerStyles,
  fileRowStyles,
  fileMetaStyles,
  fileNameStyles,
  filePreviewThumbStyles,
  filePreviewThumbImageStyles,
  deleteButtonStyles,
  emptyOuterStyles,
  emptyIconsRowStyles,
  uploadButtonStyles
}
